<template>
  <div class="d-flex container-profile">
    <div class="d-flex flex-column profile-label">
      <template>
        <img
          src="@/assets/images/userPhoto.png"
          alt="Foto"
          class="profile-photo"
          v-if="!user.photoProfile"
        />

        <img :src="user.photoProfile" alt="Foto" class="profile-photo" v-if="user.photoProfile" />

        <!-- component pop-up -->
        <PhotoPopUp />
      </template>
    </div>

    <!-- user's informartions like name, user name and specialty -->
    <div class="d-flex flex-column my-2">
      <div class="profile-name">{{ user.name || 'Profile name' }}</div>
      <div class="profile-specialty username mt-1">@{{ user.userName || 'Unique Username' }}</div>
      <div class="profile-specialty mt-1">{{ user.specialty || 'Specialty' }}</div>
    </div>
  </div>
</template>
<script>
import PhotoPopUp from "./PhotoPopUp";
export default {
  components: {
    PhotoPopUp,
  },
  computed: {
    // Get the user's infomations from store
    user() {
      return this.$store.state.user;
    },
    // Get the user's token from store
    token() {
      return this.$store.state.token;
    },
  },
};
</script>

<style>
.profile-label {
  width: 30%;
  /* border: none; */
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.profile-photo {
  width: 70px;
  height: 70px;
  border-radius: 70px;
}
.profile-name {
  width: 100%;
  height: 18x;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
}
.username {
  width: 100%;
}
.profile-specialty {
  width: 100%;
  height: 12px;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.5);
}
.container-profile {
  margin: 50px auto 0px;
  width: 300px;
}
</style>